























import { GroupModel, GroupsApi } from "../../../apis";
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class ChangeNameDialog extends Vue {
  @Prop({ default: false }) value: Boolean;
  @Prop() selectedGroup: GroupModel;
  name: string = "";

  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }


  async onSave() {
    await new GroupsApi().putDoUpdateGroup({
      putGroupRequest: { groupId: this.selectedGroup.id, name: this.name },
    });
    this.show = false;
    this.$emit("onSave", "saved");
  }

  onClose() {
    this.$emit("onClose", "closed");
  }

  @Watch("show")
  onShowChanged(value: string, oldValue: string) {
    if (!value) this.onClose();
  }

  @Watch("selectedGroup")
  onSelectedGroupChanged(value: GroupModel) {
    this.name = value.name;
  }
}
